import { useState } from 'react'
import {
  FaTruck,
  FaShippingFast,
  FaWarehouse,
  FaGlobeEurope,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaCheckCircle,
  FaBars,
  FaTimes,
  FaArrowRight,
  FaStar,
  FaShieldAlt,
  FaClock,
  FaUsers,
  FaChevronDown,
  FaIndustry,
  FaBoxOpen,
  FaTemperatureLow,
} from 'react-icons/fa'
import styles from './transport.module.scss'

const Transport = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [openFaq, setOpenFaq] = useState<number | null>(null)

  const services = [
    {
      icon: <FaTruck />,
      title: 'Transport drogowy FTL',
      desc: 'Całopojazdowe zlecenia transportowe na terenie Polski i Europy. Szybko, bezpiecznie, z pełnym monitoringiem GPS.',
    },
    {
      icon: <FaBoxOpen />,
      title: 'Transport LTL / drobnica',
      desc: 'Przewóz mniejszych przesyłek w systemie grupowym. Optymalne koszty, regularne kursowania.',
    },
    {
      icon: <FaTemperatureLow />,
      title: 'Transport chłodniczy',
      desc: 'Flota pojazdów chłodniczych dla branży spożywczej i farmaceutycznej. Utrzymanie temperatury w całym łańcuchu dostaw.',
    },
    {
      icon: <FaWarehouse />,
      title: 'Magazynowanie i logistyka',
      desc: 'Nowoczesne magazyny w kluczowych lokalizacjach. Kompletacja, etykietowanie, zarządzanie zapasami.',
    },
    {
      icon: <FaGlobeEurope />,
      title: 'Transport międzynarodowy',
      desc: 'Przewozy do krajów UE i poza nią. Obsługa celna, dokumentacja CMR, śledzenie przesyłki w czasie rzeczywistym.',
    },
    {
      icon: <FaIndustry />,
      title: 'Logistyka przemysłowa',
      desc: 'Dostosowane rozwiązania dla sektora przemysłowego. Transport maszyn, ładunki ponadgabarytowe i niestandardowe.',
    },
  ]

  const stats = [
    { value: '15+', label: 'Lat doświadczenia' },
    { value: '850+', label: 'Pojazdów w flocie' },
    { value: '120 000+', label: 'Zleceń rocznie' },
    { value: '32', label: 'Kraje obsługi' },
  ]

  const reasons = [
    {
      icon: <FaClock />,
      title: 'Punktualność 99,4%',
      desc: 'Dotrzymujemy terminów – Twoje zlecenie dotrze na czas, zawsze.',
    },
    {
      icon: <FaShieldAlt />,
      title: 'Pełne ubezpieczenie',
      desc: 'Każdy ładunek objęty jest polisą OCP i OCS. Twój towar jest bezpieczny.',
    },
    {
      icon: <FaUsers />,
      title: 'Doświadczeni kierowcy',
      desc: 'Nasi kierowcy przeszli rygorystyczne szkolenia. Profesjonalizm na każdym kilometrze.',
    },
    {
      icon: <FaShippingFast />,
      title: 'Śledzenie w czasie rzeczywistym',
      desc: 'System GPS 24/7 – wiesz dokładnie, gdzie jest Twój ładunek w każdej chwili.',
    },
  ]

  const faqs = [
    {
      q: 'Jakie kraje obsługujecie?',
      a: 'Realizujemy przewozy na terenie całej Polski oraz do 32 krajów europejskich i pozaeuropejskich, w tym do krajów WNP i Turcji. Skontaktuj się z nami, aby omówić szczegóły konkretnej trasy.',
    },
    {
      q: 'Jak uzyskać wycenę przewozu?',
      a: 'Wycenę możesz otrzymać wypełniając formularz kontaktowy, dzwoniąc na nasze infolinie lub wysyłając zapytanie e-mail. Odpowiadamy w ciągu 2 godzin roboczych.',
    },
    {
      q: 'Czy oferujecie transport ponadgabarytowy?',
      a: 'Tak, posiadamy specjalistyczny sprzęt do przewozu ładunków ponadgabarytowych i ciężkich. Zapewniamy kompleksową obsługę, w tym uzyskanie niezbędnych zezwoleń i pilotaż trasy.',
    },
    {
      q: 'Jak monitorować status przesyłki?',
      a: 'Każdy klient otrzymuje dostęp do platformy śledzenia on-line. Możliwe jest również ustawienie automatycznych powiadomień SMS i e-mail o kluczowych zdarzeniach podczas przewozu.',
    },
    {
      q: 'Czy obsługujecie klientów indywidualnych?',
      a: 'Obsługujemy zarówno firmy, jak i klientów indywidualnych. Dla stałych klientów biznesowych oferujemy specjalne stawki kontraktowe i dedykowanego opiekuna handlowego.',
    },
  ]

  const testimonials = [
    {
      name: 'Marek Kowalski',
      company: 'ProBuild Sp. z o.o.',
      text: 'Współpracujemy z VeloTrans od 8 lat. Niezawodność i terminowość na najwyższym poziomie. Polecam każdej firmie szukającej solidnego partnera logistycznego.',
      stars: 5,
    },
    {
      name: 'Anna Wiśniewska',
      company: 'FoodExport S.A.',
      text: 'Transport chłodniczy realizowany przez VeloTrans spełnia nasze bardzo wysokie wymagania. Zero problemów z temperaturą, zawsze na czas.',
      stars: 5,
    },
    {
      name: 'Tomasz Nowak',
      company: 'EuroDistrib GmbH',
      text: 'Obsługa transportu międzynarodowego przez VeloTrans to czysta przyjemność. Dokumentacja, śledzenie GPS, komunikacja – wszystko działa bez zarzutu.',
      stars: 5,
    },
  ]

  return (
    <div className={styles.page}>
      {/* ===== NAVBAR ===== */}
      <nav className={styles.navbar}>
        <div className={styles.navInner}>
          <a
            href='#'
            className={styles.logo}
          >
            <span className={styles.logoIcon}>
              <FaTruck />
            </span>
            <span>
              Velo<strong>Trans</strong>
            </span>
          </a>

          <ul className={`${styles.navLinks} ${menuOpen ? styles.navOpen : ''}`}>
            <li>
              <a
                href='#uslugi'
                onClick={() => setMenuOpen(false)}
              >
                Usługi
              </a>
            </li>
            <li>
              <a
                href='#dlaczego-my'
                onClick={() => setMenuOpen(false)}
              >
                Dlaczego my
              </a>
            </li>
            <li>
              <a
                href='#flota'
                onClick={() => setMenuOpen(false)}
              >
                Flota
              </a>
            </li>
            <li>
              <a
                href='#faq'
                onClick={() => setMenuOpen(false)}
              >
                FAQ
              </a>
            </li>
            <li>
              <a
                href='#kontakt'
                className={styles.navCta}
                onClick={() => setMenuOpen(false)}
              >
                Kontakt
              </a>
            </li>
          </ul>

          <button
            className={styles.hamburger}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label='Menu'
          >
            {menuOpen ?
              <FaTimes />
            : <FaBars />}
          </button>
        </div>
      </nav>

      {/* ===== HERO ===== */}
      <section className={styles.hero}>
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <div className={styles.heroBadge}>
            <FaShippingFast /> Szybko · Bezpiecznie · Niezawodnie
          </div>
          <h1 className={styles.heroTitle}>
            Twój ładunek.
            <br />
            <span className={styles.heroAccent}>Nasza odpowiedzialność.</span>
          </h1>
          <p className={styles.heroDesc}>
            Profesjonalne usługi transportowe i logistyczne na terenie Polski i Europy.
            <br />
            Ponad 15 lat doświadczenia, 850 pojazdów, 32 kraje.
          </p>
          <div className={styles.heroButtons}>
            <a
              href='#kontakt'
              className={styles.btnPrimary}
            >
              Zamów przewóz <FaArrowRight />
            </a>
            <a
              href='#uslugi'
              className={styles.btnSecondary}
            >
              Nasze usługi
            </a>
          </div>
          <div className={styles.heroScroll}>
            <FaChevronDown />
          </div>
        </div>

        <div className={styles.heroStripes}>
          <span />
          <span />
          <span />
        </div>
      </section>

      {/* ===== STATS ===== */}
      <section className={styles.statsBar}>
        {stats.map((s) => (
          <div
            key={s.label}
            className={styles.statItem}
          >
            <span className={styles.statValue}>{s.value}</span>
            <span className={styles.statLabel}>{s.label}</span>
          </div>
        ))}
      </section>

      {/* ===== SERVICES ===== */}
      <section
        id='uslugi'
        className={styles.services}
      >
        <div className={styles.sectionInner}>
          <div className={styles.sectionHeader}>
            <span className={styles.sectionTag}>Co robimy</span>
            <h2 className={styles.sectionTitle}>Kompleksowe usługi transportowe</h2>
            <p className={styles.sectionSubtitle}>
              Oferujemy pełne spektrum usług logistycznych – od drobnych przesyłek po wielkie
              ładunki przemysłowe.
            </p>
          </div>

          <div className={styles.servicesGrid}>
            {services.map((svc) => (
              <div
                key={svc.title}
                className={styles.serviceCard}
              >
                <div className={styles.serviceIcon}>{svc.icon}</div>
                <h3 className={styles.serviceTitle}>{svc.title}</h3>
                <p className={styles.serviceDesc}>{svc.desc}</p>
                <a
                  href='#kontakt'
                  className={styles.serviceLink}
                >
                  Dowiedz się więcej <FaArrowRight />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== WHY US ===== */}
      <section
        id='dlaczego-my'
        className={styles.whyUs}
      >
        <div className={styles.sectionInner}>
          <div className={styles.sectionHeader}>
            <span className={styles.sectionTagLight}>Nasza przewaga</span>
            <h2 className={`${styles.sectionTitle} ${styles.light}`}>Dlaczego warto nam zaufać?</h2>
          </div>

          <div className={styles.reasonsGrid}>
            {reasons.map((r) => (
              <div
                key={r.title}
                className={styles.reasonCard}
              >
                <div className={styles.reasonIcon}>{r.icon}</div>
                <h3 className={styles.reasonTitle}>{r.title}</h3>
                <p className={styles.reasonDesc}>{r.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== FLEET ===== */}
      <section
        id='flota'
        className={styles.fleet}
      >
        <div className={styles.sectionInner}>
          <div className={styles.sectionHeader}>
            <span className={styles.sectionTag}>Nasz sprzęt</span>
            <h2 className={styles.sectionTitle}>Nowoczesna flota</h2>
            <p className={styles.sectionSubtitle}>
              Regularnie odnawiana flota z pełnym wyposażeniem telematycznym i spełniająca normy
              Euro 6.
            </p>
          </div>

          <div className={styles.fleetGrid}>
            {[
              { name: 'Ciągniki siodłowe', count: '340+', norm: 'Euro 6', payload: 'do 24 t' },
              { name: 'Busy i dostawczaki', count: '210+', norm: 'Euro 6', payload: 'do 3,5 t' },
              {
                name: 'Chłodnie i izotermy',
                count: '160+',
                norm: 'ATP cert.',
                payload: '-25°C / +25°C',
              },
              {
                name: 'Naczepy specjalistyczne',
                count: '140+',
                norm: 'Euro 6',
                payload: 'ponadgabaryt',
              },
            ].map((v) => (
              <div
                key={v.name}
                className={styles.fleetCard}
              >
                <FaTruck className={styles.fleetIcon} />
                <div className={styles.fleetCount}>{v.count}</div>
                <div className={styles.fleetName}>{v.name}</div>
                <div className={styles.fleetMeta}>
                  <span>
                    <FaCheckCircle /> {v.norm}
                  </span>
                  <span>
                    <FaCheckCircle /> {v.payload}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== TESTIMONIALS ===== */}
      <section className={styles.testimonials}>
        <div className={styles.sectionInner}>
          <div className={styles.sectionHeader}>
            <span className={styles.sectionTagLight}>Opinie klientów</span>
            <h2 className={`${styles.sectionTitle} ${styles.light}`}>Co mówią o nas klienci?</h2>
          </div>

          <div className={styles.testimonialsGrid}>
            {testimonials.map((t) => (
              <div
                key={t.name}
                className={styles.testimonialCard}
              >
                <div className={styles.testimonialStars}>
                  {Array.from({ length: t.stars }).map((_, i) => (
                    <FaStar key={i} />
                  ))}
                </div>
                <p className={styles.testimonialText}>"{t.text}"</p>
                <div className={styles.testimonialAuthor}>
                  <strong>{t.name}</strong>
                  <span>{t.company}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== FAQ ===== */}
      <section
        id='faq'
        className={styles.faq}
      >
        <div className={styles.sectionInner}>
          <div className={styles.sectionHeader}>
            <span className={styles.sectionTag}>FAQ</span>
            <h2 className={styles.sectionTitle}>Najczęstsze pytania</h2>
          </div>

          <div className={styles.faqList}>
            {faqs.map((f, i) => (
              <div
                key={i}
                className={`${styles.faqItem} ${openFaq === i ? styles.faqOpen : ''}`}
              >
                <button
                  className={styles.faqQuestion}
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                >
                  <span>{f.q}</span>
                  <FaChevronDown className={styles.faqArrow} />
                </button>
                <div className={styles.faqAnswer}>
                  <p>{f.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== CTA BANNER ===== */}
      <section className={styles.ctaBanner}>
        <div className={styles.ctaBannerInner}>
          <h2 className={styles.ctaBannerTitle}>Gotowy na sprawną logistykę?</h2>
          <p className={styles.ctaBannerDesc}>
            Skontaktuj się z nami już dziś – bezpłatna wycena w ciągu 2 godzin.
          </p>
          <a
            href='#kontakt'
            className={styles.btnPrimaryDark}
          >
            Zamów wycenę <FaArrowRight />
          </a>
        </div>
      </section>

      {/* ===== CONTACT ===== */}
      <section
        id='kontakt'
        className={styles.contact}
      >
        <div className={styles.sectionInner}>
          <div className={styles.sectionHeader}>
            <span className={styles.sectionTag}>Kontakt</span>
            <h2 className={styles.sectionTitle}>Skontaktuj się z nami</h2>
            <p className={styles.sectionSubtitle}>
              Nasz zespół jest do dyspozycji od poniedziałku do piątku w godzinach 7:00–20:00.
            </p>
          </div>

          <div className={styles.contactLayout}>
            <div className={styles.contactInfo}>
              <div className={styles.contactItem}>
                <div className={styles.contactIcon}>
                  <FaPhoneAlt />
                </div>
                <div>
                  <strong>Infolinia</strong>
                  <span>+48 800 123 456</span>
                </div>
              </div>
              <div className={styles.contactItem}>
                <div className={styles.contactIcon}>
                  <FaEnvelope />
                </div>
                <div>
                  <strong>E-mail</strong>
                  <span>kontakt@velotrans.pl</span>
                </div>
              </div>
              <div className={styles.contactItem}>
                <div className={styles.contactIcon}>
                  <FaMapMarkerAlt />
                </div>
                <div>
                  <strong>Siedziba</strong>
                  <span>ul. Transportowa 12, 00-001 Warszawa</span>
                </div>
              </div>

              <div className={styles.certBadges}>
                <div className={styles.cert}>
                  <FaCheckCircle /> ISO 9001:2015
                </div>
                <div className={styles.cert}>
                  <FaCheckCircle /> ATP Certified
                </div>
                <div className={styles.cert}>
                  <FaCheckCircle /> SQAS Approved
                </div>
              </div>
            </div>

            <form className={styles.contactForm}>
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label>Imię i nazwisko</label>
                  <input
                    type='text'
                    placeholder='Jan Kowalski'
                  />
                </div>
                <div className={styles.formGroup}>
                  <label>Firma</label>
                  <input
                    type='text'
                    placeholder='Nazwa firmy'
                  />
                </div>
              </div>
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label>E-mail</label>
                  <input
                    type='email'
                    placeholder='jan@firma.pl'
                  />
                </div>
                <div className={styles.formGroup}>
                  <label>Telefon</label>
                  <input
                    type='tel'
                    placeholder='+48 000 000 000'
                  />
                </div>
              </div>
              <div className={styles.formGroup}>
                <label>Rodzaj usługi</label>
                <select>
                  <option>Transport FTL</option>
                  <option>Transport LTL / drobnica</option>
                  <option>Transport chłodniczy</option>
                  <option>Transport międzynarodowy</option>
                  <option>Magazynowanie</option>
                  <option>Inne</option>
                </select>
              </div>
              <div className={styles.formGroup}>
                <label>Wiadomość</label>
                <textarea
                  rows={4}
                  placeholder='Opisz swoje zapotrzebowanie transportowe...'
                />
              </div>
              <button
                type='submit'
                className={styles.formSubmit}
              >
                Wyślij zapytanie <FaArrowRight />
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer className={styles.footer}>
        <div className={styles.footerInner}>
          <div className={styles.footerLogo}>
            <FaTruck />
            <span>
              Velo<strong>Trans</strong>
            </span>
          </div>
          <p className={styles.footerText}>
            © {new Date().getFullYear()} VeloTrans Sp. z o.o. Wszelkie prawa zastrzeżone.
          </p>
          <div className={styles.footerLinks}>
            <a href='#'>Polityka prywatności</a>
            <a href='#'>Regulamin</a>
            <a href='#kontakt'>Kontakt</a>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Transport
